import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPageState } from '../reducers/page.reducers';

export const getPageState = createFeatureSelector<IPageState>('pageInfo');

export const getPageTitle = createSelector(
  getPageState,
  (state: IPageState) => state.title
);
